import { useState } from "react";
import { calculateTime } from "../../../utils/mediaUtils";

export const useMediaRecorder = ({
    mediaRef = null,
    mediaUrl = "",
    startRecording = () => {},
    discardRecording = () => {},

}) => {
    const [time, setTime] = useState("");
    const [seekProgress, setSeekProgress] = useState(0);
    const [maxValue, setMaxValue] = useState(100);

    const [isPlaying, setIsPlaying] = useState(false);

    const handleMediaTimeUpdated = () => {
        if(!mediaRef.current) return;
            
        setSeekProgress(mediaRef.current.currentTime);
        setTime(calculateTime(Math.floor(mediaRef.current.currentTime)));
    }

    const handleStartRecording = () => {
        if(mediaRef.current){
          // re-scan for changes on `mediaUrl` to refresh the audio source
          mediaRef.current.load();
        }
        if(mediaUrl) {
          handleDiscardMedia();
          setTimeout(() => {
            startRecording();
          }, 500);
          return
        }
        startRecording();
    }

    const handleTogglePause = () => {
        if(!mediaRef.current || !mediaUrl) return;
        
        setIsPlaying(mediaRef.current.paused);
        
        if(mediaRef.current.paused) {
          mediaRef.current.play();
        } else {
          mediaRef.current.pause();
        }
    }

    const handleDiscardMedia = () => {
        if(mediaRef.current && !mediaRef.current.paused) {
          mediaRef.current.pause();
        }
        setIsPlaying(false);
        setTime("");
        setSeekProgress(0);
        discardRecording();
    }

    const handleSeek = (progress) => {
        if (mediaRef.current) {
          mediaRef.current.currentTime = Number(progress);
        }
    }
    
    const handleEnded = () => {
        if (mediaRef.current) {
          setSeekProgress(maxValue);
        }
        setIsPlaying(false);
    }

    return {
        isPlaying,
        setIsPlaying,
        time,
        setTime,
        seekProgress,
        maxValue,
        setMaxValue,
        handleMediaTimeUpdated,
        handleStartRecording,
        handleTogglePause,
        handleDiscardMedia,
        handleSeek,
        handleEnded,
    }
}